import OrdersIcon from '@apps-common/ui-icons/Orders.jsx';

export default OrdersIcon;
